import { Typography } from '@material-ui/core';
import React from 'react';

const Description = ({ classes }) => (
  <ol className={classes.root}>
    <Typography gutterBottom component="li" className={classes.item}>
      Данный аккаунт был создан для доступа в API
    </Typography>

    <Typography component="li" className={classes.item}>
      Доступа на сайт не имеется
    </Typography>
  </ol>
);

export default Description;
